export var QueryTreeNodeType;
(function (QueryTreeNodeType) {
    QueryTreeNodeType["FILL"] = "fill";
    QueryTreeNodeType["HYDRATE"] = "hydrate";
    QueryTreeNodeType["PAGINATE"] = "paginate";
    QueryTreeNodeType["FILTER"] = "filter";
    QueryTreeNodeType["SORT"] = "sort";
    QueryTreeNodeType["SCAN"] = "scan";
    QueryTreeNodeType["SCAN_ALL"] = "scan-all";
    QueryTreeNodeType["INDEX_SCAN"] = "index-scan";
    QueryTreeNodeType["UNION"] = "union";
    QueryTreeNodeType["DISTINCT"] = "distinct";
    QueryTreeNodeType["INTERSECT"] = "intersect";
})(QueryTreeNodeType || (QueryTreeNodeType = {}));
//# sourceMappingURL=query-tree.js.map